var _path, _path2, _path3, _path4, _mask, _g, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 550,
    viewBox: "0 0 640 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.535 302.471V35.7664L8.91895 0V356.816L52.9938 352.822L68.0083 351.43L95.9789 348.888L110.993 347.497L138.964 344.955L153.979 343.563L181.949 341.021L196.964 339.629L224.934 337.087L238.622 335.818L224.995 337.027V148.996H240.009V335.69L267.919 333.154L282.934 331.762L364.545 324.318L372.779 323.592H372.9L379.196 323.047L387.127 322.321L389.61 322.079L394.332 321.655L399.841 321.171L414.735 319.779L420.971 319.234L598.299 303.016L604.535 302.471ZM68.1898 276.448V351.309L53.1753 352.701V276.448H68.1898ZM111.115 347.375V246.794H96.1V348.767L111.115 347.375ZM154.1 195.535V343.502L139.085 344.834V195.535H154.1ZM197.024 339.569V136.287H182.009V340.961L197.024 339.569ZM282.934 331.762V107.481H267.919V333.154L282.934 331.762Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5547 317.43C49.5547 317.43 249.033 280.45 330.421 139.104L336.998 142.86C336.998 142.86 266.708 273.406 49.5547 321.363V317.43V317.43Z",
    fill: "#80A1F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319.734 139.103L341.814 152.897V129.652L319.734 139.103Z",
    fill: "#80A1F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5806 95.4898C68.5806 123.137 91.0123 145.56 118.67 145.56C146.328 145.56 168.76 123.137 168.76 95.4898C168.76 67.8428 146.328 45.4199 118.67 45.4199C91.0123 45.4199 68.5806 67.8428 68.5806 95.4898ZM88.135 95.9007C88.135 79.0542 101.817 65.3774 118.67 65.3774C135.524 65.3774 149.206 79.0542 149.206 95.9007C149.206 112.747 135.524 126.424 118.67 126.424C101.817 126.424 88.135 112.747 88.135 95.9007Z",
    fill: "#FE5B88"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 45,
    width: 101,
    height: 101
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5806 95.4898C68.5806 123.137 91.0123 145.56 118.67 145.56C146.328 145.56 168.76 123.137 168.76 95.4898C168.76 67.8428 146.328 45.4199 118.67 45.4199C91.0123 45.4199 68.5806 67.8428 68.5806 95.4898ZM88.135 95.9007C88.135 79.0542 101.817 65.3774 118.67 65.3774C135.524 65.3774 149.206 79.0542 149.206 95.9007C149.206 112.747 135.524 126.424 118.67 126.424C101.817 126.424 88.135 112.747 88.135 95.9007Z",
    fill: "#FE5B88"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.2 36.5566V95.49L61.4751 65.3776L118.2 36.5566Z",
    fill: "#FFB5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5874 131.589L61.4751 65.377L118.2 95.4893L64.5874 131.589Z",
    fill: "#FE84A6"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.979 455.739C638.907 448.585 637.688 441.331 636.304 434.005C617.39 333.907 574.23 305.833 543.974 286.153C543.607 285.913 543.241 285.676 542.877 285.439L543.934 280.038C533.305 273.523 526.318 270.529 526.318 270.529L454.266 290.369C454.266 290.369 437.295 297.589 419.737 310.562L425.844 317.664C415.275 324.708 406.408 335.626 400.007 347.601C409.344 357.286 421.558 376.245 427.547 398.081C434.521 423.393 439.594 448.67 443.209 472.27L639.979 455.739Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M340.933 276.164C340.933 276.164 353.265 302.226 347.275 324.062C347.275 324.062 346.981 319.425 340.228 317.194C338.056 312.792 336.118 291.778 336.118 291.778L340.933 276.164Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M307.05 389.394C307.05 389.394 354.732 363.273 367.651 327.408L340.933 316.725L336.117 290.369L280.684 294.243C280.684 294.243 284.266 315.61 284.677 324.532C273.696 325.353 260.895 331.693 260.895 331.693L258.311 335.684L256.021 343.139C255.962 343.198 274.988 366.56 307.05 389.394Z",
    fill: "#FFB5C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.166 343.609C318.031 347.19 320.439 340.909 320.439 340.909C320.439 340.909 319.558 316.549 321.202 309.799C322.846 303.048 328.66 300.055 328.66 300.055L306.522 292.365L280.684 294.185C280.684 294.185 284.266 315.551 284.677 324.473C277.807 325.002 270.231 327.643 265.534 329.58L264.418 337.915L279.216 366.854C286.85 373.78 296.245 381.587 307.168 389.335C307.168 389.335 314.919 385.109 324.96 377.713C323.962 377.067 322.729 376.363 321.261 375.717C298.418 365.738 298.301 340.028 308.166 343.609Z",
    fill: "url(#paint1_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M280.625 294.243C280.625 294.243 284.266 313.262 284.618 324.532C260.836 332.456 241.634 340.204 241.634 340.204L245.744 287.434L270.408 276.164L280.625 294.243Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M277.866 179.722C284.149 172.971 309.752 168.217 324.549 186.942C329.365 193.046 334.062 199.738 334.65 209.599C337.351 258.437 266.532 198.153 266.532 198.153C266.532 198.153 269.175 189.055 277.866 179.722Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M289.962 183.949C315.506 188.234 327.544 196.745 334.65 215.177C334.65 224.393 337.468 228.678 341.755 232.904C346.042 237.189 351.679 264.131 341.755 290.37C335.354 306.688 312.688 302.403 312.688 302.403C312.688 302.403 293.544 304.516 280.743 298.881C267.942 293.187 260.895 255.62 260.895 255.62L266.591 198.154L289.962 183.949Z",
    fill: "#FFB5C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M332.418 284.734C329.482 284.617 327.074 285.85 325.313 286.202C322.905 286.73 322.259 283.56 324.725 282.093C322.494 283.091 319.675 283.56 311.278 281.917C303.585 280.449 298.301 274.638 296.95 272.995C297.067 272.76 297.126 272.584 297.244 272.349C301.295 265.012 316.269 256.031 316.269 256.031C316.269 256.031 319.029 255.62 320.85 256.031C320.497 254.857 320.38 253.859 320.321 253.096C320.908 252.92 321.437 252.744 321.848 252.45C325.43 250.102 325.019 245.172 323.257 245.582C321.496 245.993 318.266 246.58 315.858 244.995C313.451 243.411 306.874 238.656 305.582 228.677C304.819 222.514 298.77 217.877 294.307 217.583C289.786 217.29 279.216 217.583 270.408 222.983C267.53 224.744 265.24 226.681 263.537 228.325L260.836 255.561C260.836 255.561 267.941 293.128 280.684 298.822C293.485 304.516 312.629 302.344 312.629 302.344C312.629 302.344 332.594 306.101 340.345 293.128C340.287 287.728 336.881 284.969 332.418 284.734Z",
    fill: "url(#paint2_radial)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M526.259 270.529C526.259 270.529 525.32 275.929 512.577 288.491C499.717 303.048 485.212 314.26 474.173 321.714C473.644 322.067 473.116 322.419 472.587 322.771C472.176 323.064 471.765 323.299 471.354 323.593C471.061 323.769 470.767 324.004 470.473 324.18C469.886 324.591 469.299 324.943 468.712 325.295C468.418 325.471 468.124 325.647 467.89 325.823C466.421 326.762 465.012 327.584 463.779 328.347C463.427 328.582 463.074 328.758 462.722 328.993C460.549 330.284 458.846 331.224 457.789 331.752C457.731 331.811 457.613 331.869 457.555 331.869C456.909 332.221 456.556 332.397 456.556 332.397C456.556 332.397 456.556 332.398 456.497 332.339C455.44 330.05 432.539 281.388 432.539 279.51C432.539 276.693 432.598 269.12 432.598 269.12C432.598 269.12 432.539 269.12 432.48 269.12C430.836 269.297 413.337 270.999 396.425 266.244C382.919 267.653 381.51 252.744 385.092 248.517C388.615 244.291 385.092 240.71 385.092 240.71H382.978C382.978 240.71 380.159 240.006 380.159 236.484C380.159 232.962 385.15 227.973 385.15 227.973C385.15 227.973 378.75 222.279 380.922 219.461C385.914 214.472 385.914 208.837 385.914 208.837C375.99 206.019 375.285 198.917 375.285 198.917C375.285 198.917 388.791 187.588 399.42 179.781C400.829 172.679 394.428 164.872 396.601 159.941C400.124 149.317 411.928 135.464 422.85 127.305C448.394 108.169 495.959 115.976 511.52 134.407C527.14 152.839 527.845 182.657 518.625 199.68C509.406 216.703 510.815 228.031 512.225 240.123C513.458 252.039 526.259 270.529 526.259 270.529Z",
    fill: "#FFB5C9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M304.114 276.165C337.468 278.278 336 264.718 336 264.366C334.356 263.075 328.895 263.192 328.895 263.192C326.018 265.481 299.182 272.584 299.182 272.584L304.114 276.165Z",
    fill: "#FE5B88"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M303.292 275.577C303.292 275.577 311.924 270.47 323.258 269.062C328.249 268.357 332.477 268.357 332.477 268.357V263.368C332.477 263.368 321.144 261.959 309.752 266.89C299.828 271.234 299.123 272.584 299.123 272.584L303.292 275.577Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M308.812 276.401C308.812 276.401 318.266 271.47 328.249 270.766V273.759C328.249 273.759 323.199 276.577 308.812 276.401Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M328.132 248.812C325.548 250.279 325.078 251.864 325.078 251.864C325.078 251.864 327.779 250.925 329.482 251.336C331.185 251.805 331.009 247.227 328.132 248.812Z",
    fill: "#FE5B88"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M294.601 180.603C294.601 180.603 283.679 187.236 276.691 198.623C271.289 207.487 266.532 219.755 266.532 258.085C266.532 276.634 271.23 288.843 279.627 302.872C287.496 316.02 262.245 335.919 258.252 346.133C249.503 368.556 249.092 401.72 255.962 436.998H244.453C244.453 436.998 171.696 369.73 222.491 222.513C233.296 191.227 262.069 162.347 294.601 180.603Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M276.867 305.572C282.798 329.756 278.277 412.11 272.346 443.397H268.94C268.94 443.397 278.688 364.447 266.65 328.054C254.612 291.661 276.867 305.572 276.867 305.572Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M274.988 365.68L263.126 357.755C263.126 357.755 262.422 398.081 271.406 427.607V435.12C271.406 435.12 240.988 409.821 243.22 364.799C245.451 319.777 263.126 314.318 263.126 314.318L271.406 327.526L274.988 365.68Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M460.725 336.389L482.805 328.934C485.153 328.171 487.737 328.406 489.851 329.698C494.373 332.456 502.242 337.622 505.53 342.552C483.098 335.039 460.725 336.389 460.725 336.389Z",
    fill: "url(#paint3_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M542.76 285.439C542.76 285.439 531.074 325.531 521.679 344.021C547.575 330.813 562.725 300.642 562.725 300.642C562.725 300.642 551.216 290.722 542.76 285.439Z",
    fill: "url(#paint4_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M396.366 159.824C394.252 164.813 400.653 172.62 399.184 179.664C388.556 187.471 375.05 198.8 375.05 198.8C375.05 198.8 375.754 205.902 385.678 208.72C385.678 208.72 385.678 214.414 380.687 219.344C378.573 222.162 384.974 227.856 384.974 227.856C384.974 227.856 379.982 232.845 379.982 236.367C379.982 239.889 382.801 240.652 382.801 240.652H384.915C384.915 240.652 388.438 244.174 384.915 248.459C381.392 252.744 382.801 267.595 396.248 266.186C413.982 271.175 432.421 269.003 432.421 269.003C432.421 269.003 432.421 269.062 432.421 269.179L450.507 256.97C434.594 266.421 419.62 264.718 419.62 264.718C426.725 235.663 406.818 212.946 399.067 205.139C402.59 188.117 413.278 183.832 419.62 182.423C416.096 181.719 413.924 178.901 415.333 178.138C416.742 177.434 422.438 178.138 422.438 178.138L416.742 168.218C428.78 136.286 451.506 129.183 451.506 129.183L434.241 120.555C429.955 122.198 425.962 124.37 422.38 127.07C411.751 135.405 399.948 149.2 396.366 159.824Z",
    fill: "url(#paint5_radial)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M474.114 321.655C474.114 321.655 474.114 321.714 474.114 321.655C473.585 322.007 472.998 322.36 472.528 322.712C472.117 323.005 471.706 323.24 471.295 323.534C471.002 323.71 470.708 323.944 470.414 324.121C469.827 324.531 469.24 324.884 468.653 325.236C468.359 325.412 468.066 325.588 467.831 325.764C466.363 326.703 464.953 327.525 463.72 328.288C463.368 328.523 463.015 328.699 462.663 328.934C460.49 330.225 458.788 331.164 457.731 331.693C457.672 331.751 457.554 331.81 457.496 331.81C456.85 332.162 456.497 332.338 456.497 332.338C456.497 332.338 456.497 332.338 456.439 332.28C455.382 329.99 432.48 281.329 432.48 279.451C432.48 276.633 432.539 269.061 432.539 269.061C432.539 269.061 432.48 269.061 432.421 269.061C438.176 264.6 447.102 259.669 456.439 252.273C456.439 252.273 450.038 266.361 448.159 277.573C448.805 283.149 468.829 313.672 474.114 321.655Z",
    fill: "url(#paint6_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M414.1 128.655C415.509 130.064 418.563 130.475 418.563 130.475C418.563 130.475 429.015 128.655 438.939 132.177C429.015 141.393 428.076 147.967 428.076 147.967C428.076 147.967 438.939 157.711 441.053 171.153C437.53 186.062 441.053 199.504 441.053 199.504L446.749 202.322C446.749 202.322 451.741 177.492 467.302 177.492C482.922 177.492 478.107 197.919 478.107 197.919C478.107 197.919 484.625 236.426 511.813 238.187C511.813 238.187 510.58 226.447 512.753 215.118C514.867 203.789 529.078 193.106 526.259 165.459C523.44 137.812 505.706 115.096 465.247 114.391C424.787 113.687 414.1 128.655 414.1 128.655Z",
    fill: "#0B45E6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M314.743 213.299C312.511 215.471 312.511 225.45 316.211 230.968C319.969 236.485 323.375 237.601 325.665 239.596C323.962 236.485 323.257 233.609 323.962 231.555C328.719 231.907 334.884 230.968 338.76 229.617C336.176 226.213 334.591 222.045 334.591 215.178C334.121 213.945 333.592 212.712 333.064 211.538C328.777 210.775 318.736 209.484 314.743 213.299Z",
    fill: "url(#paint7_radial)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.715 457.967C105.88 454.042 93.9914 470.799 93.9914 470.799C95.1097 456.268 84.1626 445.487 69.39 458.026C58.0899 467.635 59.679 473.788 55.206 482.401C50.321 491.717 43.1996 490.721 43.3173 503.553C43.3173 503.553 59.0904 489.491 68.3895 490.252L44.2001 513.514L39.6683 549.139C39.6683 549.139 41.5516 542.811 47.6137 543.279C53.7346 543.748 87.5174 549.607 96.4633 541.99C105.409 534.373 85.7517 508.885 86.046 505.545C86.3403 502.205 92.7555 498.573 104.232 508.651C115.709 518.729 114.532 529.803 114.591 528.455C114.708 527.108 134.719 510.994 133.307 502.733C131.894 494.471 99.8769 481.463 99.8769 481.463C99.8769 481.463 111.589 475.604 121.653 477.713C131.717 479.823 143.959 497.459 144.136 495.76C144.371 494.061 147.549 461.893 126.715 457.967ZM99.053 449.53C99.053 449.53 102.937 441.268 103.761 430.721C100.112 430.839 95.9336 430.897 93.6383 430.897C88.871 430.839 89.0476 423.807 93.8149 422.636C96.5222 421.932 99.9358 421.698 103.644 421.522C102.937 415.604 100.877 409.511 96.4633 404.061C87.9294 406.991 80.6313 406.347 91.1075 398.554C75.7464 385.312 51.6747 385.78 0 400.546C22.4238 403.124 38.9031 411.913 51.0861 418.593C72.6859 430.487 99.053 449.53 99.053 449.53ZM220 424.862C220 424.862 218.705 413.847 215.409 405.409C204.109 411.034 201.166 403.124 208.229 397.909C208.229 397.909 199.46 374.062 173.328 378.749C147.196 383.495 158.85 401.366 144.254 407.05C134.837 410.741 125.479 392.108 114.002 413.964C103.114 434.823 119.123 456.678 160.615 456.444C160.615 456.444 164.735 438.749 170.562 439.862C177.271 441.151 173.446 450.526 169.444 459.667L187.924 466.229C187.924 466.229 193.221 451.932 197.223 453.69C201.284 455.448 194.163 468.573 194.163 468.573L201.873 471.678C201.873 471.678 218.411 445.546 219.058 430.136C204.757 430.546 194.869 422.929 220 424.862Z",
    fill: "#4072F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 782.211,
    y1: 413.176,
    x2: -48.5304,
    y2: 33.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#668EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2613,
    stopColor: "#507EF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8043,
    stopColor: "#1654ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 335.93,
    y1: 377.812,
    x2: 275.994,
    y2: 294.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    stopColor: "#FEADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#FEA7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    stopColor: "#FE94B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7628,
    stopColor: "#FE779C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#FE5B88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(304.138 260.758) rotate(-16.868) scale(93.8396 93.8087)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1965,
    stopColor: "#FEA1BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5486,
    stopColor: "#FE82A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#FE5B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 465.176,
    y1: 311.646,
    x2: 487.852,
    y2: 346.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013661,
    stopColor: "#668EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9854,
    stopColor: "#668EF3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 512.612,
    y1: 276.463,
    x2: 542.084,
    y2: 322.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013661,
    stopColor: "#668EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9854,
    stopColor: "#668EF3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(396.811 193.747) scale(88.9265 88.8912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    stopColor: "#FEADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#FEA7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    stopColor: "#FE94B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7628,
    stopColor: "#FE779C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#FE5B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 479.196,
    y1: 323.783,
    x2: 436.245,
    y2: 264.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    stopColor: "#FEADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#FEA7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    stopColor: "#FE94B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7628,
    stopColor: "#FE779C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#FE5B88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.357 193.803) scale(60.2892 60.2654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3813,
    stopColor: "#FEADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#FE8EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#FE5B88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishTop);
export default __webpack_public_path__ + "static/media/finish-top.18ddb143d375aa2df1cfb4488e60164a.svg";
export { ForwardRef as ReactComponent };